import * as actions from './actions';

export const setDutyPlannerData = (startTime, endTime, groupId, defaultFunctionId) => dispatch =>
  dispatch(actions.dutyPlannerDataReceived(startTime, endTime, groupId, defaultFunctionId));
